import React from 'react';
var ClickToAcceptSkeleton = function () { return (React.createElement("div", { className: "bg-primary-white skeleton-card" },
    React.createElement("div", { className: "container pt-3 pb-4" },
        React.createElement("h1", { className: "skeleton-line skeleton-h-xl" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-lg mb-3" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md w-75" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md" }),
        React.createElement("span", { className: "skeleton-line skeleton-h-md w-50" }),
        React.createElement("div", { className: "click-to-accept mt-4" },
            React.createElement("pre", null,
                React.createElement("span", { className: "skeleton-line skeleton-h-md w-75" }),
                React.createElement("span", { className: "skeleton-line skeleton-h-md" }),
                React.createElement("span", { className: "skeleton-line skeleton-h-md w-50" }))),
        React.createElement("span", { className: "skeleton-line skeleton-h-lg" }),
        React.createElement("button", { className: "skeleton-line skeleton-h-xl skeleton-w-lg btn" })))); };
export default React.memo(ClickToAcceptSkeleton);
